(function () {
  var mobileQuery = window.matchMedia ? window.matchMedia("(max-width: 1024px)") : { matches: true };
  var initialized = new WeakSet();
  var lastOpener = null;
  var lastDrawerOpener = null;
  var drawerWasOpen = false;
  var mobileState = isMobileViewport();
  var drawerCleanupTimer = null;
  var drawerCleanupFollowupTimer = null;
  var suppressDrawerEscapeUntil = 0;

  function isMobileViewport() {
    return window.innerWidth <= 1024;
  }

  function isVisible(element) {
    if (!element || !element.getClientRects().length) return false;
    if (element.closest('[inert], [aria-hidden="true"]')) return false;
    var style = window.getComputedStyle(element);
    return style.visibility !== "hidden" && style.display !== "none";
  }

  function focusableElements(container) {
    if (!container) return [];
    var selector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(container.querySelectorAll(selector), isVisible);
  }

  function focusDrawer(drawer) {
    var attempts = 0;

    function attemptFocus() {
      if (!drawer || !isMobileViewport() || drawer.getAttribute("aria-hidden") !== "false") return;
      if (drawer.contains(document.activeElement) && isVisible(document.activeElement)) return;

      attempts += 1;
      var close = drawer.querySelector("[data-mc-mobile-close]");
      var brand = drawer.querySelector(".mc-mobile-menu-toolbar__brand");
      var target = isVisible(close) ? close : (isVisible(brand) ? brand : null);
      if (!target && attempts >= 16) target = focusableElements(drawer)[0];
      if (target) target.focus({ preventScroll: true });

      if (!drawer.contains(document.activeElement) && attempts < 16) {
        window.setTimeout(attemptFocus, 60);
      }
    }

    window.requestAnimationFrame(attemptFocus);
  }

  function focusPanelBack(panel, back) {
    var attempts = 0;

    function attemptFocus() {
      if (!panel || !back || panel.getAttribute("aria-hidden") !== "false") return;
      if (panel.contains(document.activeElement)) return;

      attempts += 1;
      if (isVisible(back)) back.focus({ preventScroll: true });
      if (!panel.contains(document.activeElement) && attempts < 10) {
        window.setTimeout(attemptFocus, 60);
      }
    }

    window.requestAnimationFrame(attemptFocus);
  }

  function restoreDrawerFocus() {
    var opener = lastDrawerOpener || Array.prototype.find.call(document.querySelectorAll("[data-menu-drawer]"), isVisible);
    lastDrawerOpener = null;
    if (!opener || !opener.isConnected || !isVisible(opener)) return;
    window.requestAnimationFrame(function () {
      opener.focus({ preventScroll: true });
    });
  }

  function resetMenuScroll() {
    document.querySelectorAll("#t4s-menu-drawer .t4s-sp-section-mb-nav").forEach(function (section) {
      section.scrollLeft = 0;
    });
  }

  function closePanel(item, restoreFocus) {
    if (!item) return;
    var opener = item.querySelector(":scope > .mc-mobile-menu-opener");
    var panel = item.querySelector(":scope > .mc-mobile-menu-panel");
    item.classList.remove("is-panel-open");
    if (opener) opener.setAttribute("aria-expanded", "false");
    if (panel) {
      panel.setAttribute("aria-hidden", "true");
      panel.setAttribute("inert", "");
    }
    document.documentElement.classList.remove("mc-mobile-menu-panel-active");
    resetMenuScroll();
    if (restoreFocus && opener) {
      opener.focus({ preventScroll: true });
      resetMenuScroll();
    }
  }

  function closeAll(restoreFocus) {
    document.querySelectorAll(".mc-mobile-menu-item.is-panel-open").forEach(function (item) {
      closePanel(item, false);
    });
    document.documentElement.classList.remove("mc-mobile-menu-panel-active");
    if (restoreFocus && lastOpener) lastOpener.focus({ preventScroll: true });
  }

  function openPanel(item, opener) {
    if (!isMobileViewport() || !item) return;
    closeAll(false);
    var panel = item.querySelector(":scope > .mc-mobile-menu-panel");
    if (!panel) return;
    lastOpener = opener;
    panel.removeAttribute("inert");
    item.classList.add("is-panel-open");
    opener.setAttribute("aria-expanded", "true");
    panel.setAttribute("aria-hidden", "false");
    var panelScroll = panel.querySelector(".mc-mobile-menu-panel__scroll");
    if (panelScroll) panelScroll.scrollTop = 0;
    document.documentElement.classList.add("mc-mobile-menu-panel-active");
    var back = panel.querySelector(".mc-mobile-menu-panel__back");
    resetMenuScroll();
    if (back) focusPanelBack(panel, back);
  }

  function closeDrawer() {
    closeAll(false);
    var drawer = document.getElementById("t4s-menu-drawer");
    var externalClose = drawer && drawer.nextElementSibling && drawer.nextElementSibling.matches("[data-drawer-close]") ? drawer.nextElementSibling : document.querySelector(".t4s-drawer-menu__close[data-drawer-close]");
    if (externalClose) externalClose.click();
  }

  function clearDrawerLock(drawer) {
    if (!drawer || drawer.getAttribute("aria-hidden") !== "true") return;
    if (document.querySelector('.t4s-drawer[aria-hidden="false"]')) return;
    document.body.classList.remove("t4s-lock-scroll", "is--opend-drawer");
  }

  function cancelDrawerLockCleanup() {
    if (drawerCleanupTimer) window.clearTimeout(drawerCleanupTimer);
    if (drawerCleanupFollowupTimer) window.clearTimeout(drawerCleanupFollowupTimer);
    drawerCleanupTimer = null;
    drawerCleanupFollowupTimer = null;
  }

  function scheduleDrawerLockCleanup(drawer) {
    cancelDrawerLockCleanup();
    if (!drawer || drawer.getAttribute("aria-hidden") !== "true") return;

    drawerCleanupTimer = window.setTimeout(function () {
      drawerCleanupTimer = null;
      clearDrawerLock(drawer);
    }, 420);

    drawerCleanupFollowupTimer = window.setTimeout(function () {
      drawerCleanupFollowupTimer = null;
      clearDrawerLock(drawer);
    }, 620);
  }

  function syncDrawerState(drawer) {
    var isOpen = Boolean(drawer && isMobileViewport() && drawer.getAttribute("aria-hidden") === "false");
    document.documentElement.classList.toggle("mc-mobile-menu-drawer-open", isOpen);
    resetMenuScroll();
    if (isOpen && (!drawerWasOpen || !drawer.contains(document.activeElement) || !isVisible(document.activeElement))) focusDrawer(drawer);
    if (!isOpen) {
      closeAll(false);
      scheduleDrawerLockCleanup(drawer);
      if (drawerWasOpen) restoreDrawerFocus();
    }
    else cancelDrawerLockCleanup();
    drawerWasOpen = isOpen;
  }

  function bind(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    root.addEventListener("click", function (event) {
      var opener = event.target.closest(".mc-mobile-menu-opener");
      if (opener && root.contains(opener)) {
        event.preventDefault();
        openPanel(opener.closest(".mc-mobile-menu-item"), opener);
        return;
      }

      var back = event.target.closest(".mc-mobile-menu-panel__back");
      if (back && root.contains(back)) {
        event.preventDefault();
        closePanel(back.closest(".mc-mobile-menu-item"), true);
        return;
      }

      var close = event.target.closest("[data-mc-mobile-close]");
      if (close && root.contains(close)) {
        event.preventDefault();
        closeDrawer();
      }
    });
  }

  function init() {
    document.querySelectorAll(".mc-mobile-menu-panel").forEach(function (panel) {
      if (panel.getAttribute("aria-hidden") === "false") panel.removeAttribute("inert");
      else panel.setAttribute("inert", "");
    });
    document.querySelectorAll("[data-mc-mobile-menu]").forEach(bind);
    var drawer = document.getElementById("t4s-menu-drawer");
    syncDrawerState(drawer);
    if (drawer && !drawer.hasAttribute("data-mc-mobile-observed") && window.MutationObserver) {
      drawer.setAttribute("data-mc-mobile-observed", "true");
      new MutationObserver(function () {
        syncDrawerState(drawer);
        init();
      }).observe(drawer, { attributes: true, attributeFilter: ["aria-hidden"], childList: true, subtree: true });
    }
    if (drawer && !drawer.hasAttribute("data-mc-mobile-transition-observed")) {
      drawer.setAttribute("data-mc-mobile-transition-observed", "true");
      drawer.addEventListener("transitionend", function (event) {
        if (event.target === drawer && event.propertyName === "transform") clearDrawerLock(drawer);
      });
    }
  }

  document.addEventListener("keydown", function (event) {
    var drawer = document.getElementById("t4s-menu-drawer");
    var drawerIsOpen = Boolean(drawer && isMobileViewport() && drawer.getAttribute("aria-hidden") === "false");
    var openPanelElement = document.querySelector(".mc-mobile-menu-item.is-panel-open > .mc-mobile-menu-panel");

    if (event.key === "Escape" || event.keyCode === 27) {
      if (openPanelElement) {
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressDrawerEscapeUntil = Date.now() + 350;
        closeAll(true);
      }
      else if (drawerIsOpen) {
        event.preventDefault();
        closeDrawer();
      }
      return;
    }

    if (event.key !== "Tab" || !drawerIsOpen) return;
    var focusScope = openPanelElement || drawer;
    var focusable = focusableElements(focusScope);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;

    if (!focusScope.contains(active)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus({ preventScroll: true });
    }
    else if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    }
    else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  }, true);

  document.addEventListener("keyup", function (event) {
    if ((event.key !== "Escape" && event.keyCode !== 27) || Date.now() > suppressDrawerEscapeUntil) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    suppressDrawerEscapeUntil = 0;
  }, true);

  function handleBreakpointChange() {
    var drawer = document.getElementById("t4s-menu-drawer");
    var isMobile = isMobileViewport();
    if (!isMobile && drawer && drawer.getAttribute("aria-hidden") === "false") {
      closeDrawer();
      document.body.classList.remove("t4s-lock-scroll", "is--opend-drawer");
    }
    else if (!isMobile) closeAll(false);
    syncDrawerState(drawer);
  }

  function handleViewportResize() {
    var nextMobileState = isMobileViewport();
    if (nextMobileState === mobileState) return;
    mobileState = nextMobileState;
    handleBreakpointChange();
  }

  if (mobileQuery.addEventListener) mobileQuery.addEventListener("change", handleViewportResize);
  else if (mobileQuery.addListener) mobileQuery.addListener(handleViewportResize);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
  window.addEventListener("load", init, { once: true });
  window.addEventListener("resize", handleViewportResize, { passive: true });
  window.addEventListener("orientationchange", handleViewportResize, { passive: true });
  document.addEventListener("pointerdown", function (event) {
    var opener = event.target && event.target.closest ? event.target.closest("[data-menu-drawer]") : null;
    if (opener && isMobileViewport()) lastDrawerOpener = opener;
  }, true);
  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", function (event) {
    if (!event.target.closest || !event.target.closest(".t4s-sp-section-mb-nav")) return;
    var drawer = document.getElementById("t4s-menu-drawer");
    if (!drawer || drawer.getAttribute("aria-hidden") === "false" || !isMobileViewport()) return;
    var opener = Array.prototype.find.call(document.querySelectorAll("[data-menu-drawer]"), function (element) {
      return element.getClientRects().length && getComputedStyle(element).visibility !== "hidden";
    });
    if (opener) opener.click();
  });
})();
